import './Loader.scss';

export const Loader = () => (
  <div className="Loader" data-cy="loader">
    <div className="Loader__content" />
  </div>
);
